export default "__VITE_ASSET__KV265rhz__"